import { firebaseConfig, isFirebaseConfigured } from '../config/index.js';

/**
 * Lazily-initialised shared Firebase app instance.
 *
 * Both `realtimeDb.js` (group-mode sync) and `phoneAuth.js` (sign-in) need a
 * Firebase app, and a second `initializeApp()` call for the same config
 * throws — this is the one place either module goes to get it.
 *
 * Caches the in-flight promise itself, not just its resolved value: if two
 * callers both invoke this before the first `import('firebase/app')`
 * settles, they must share one `initializeApp()` call, not race two.
 *
 * @returns {Promise<import('firebase/app').FirebaseApp | null>}
 */
export function getFirebaseApp() {
  if (!isFirebaseConfigured) return Promise.resolve(null);
  if (!appPromise) {
    appPromise = import('firebase/app')
      .then(({ initializeApp, getApps }) => getApps()[0] ?? initializeApp(firebaseConfig))
      .catch((error) => {
        console.warn('[crave] Firebase unavailable:', error.message);
        return null;
      });
  }
  return appPromise;
}

/** @type {Promise<import('firebase/app').FirebaseApp | null> | undefined} */
let appPromise;
